import * as React from 'react'
import {
  Box,
  Container,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import PictureAsPdfOutlinedIcon from '@material-ui/icons/PictureAsPdfOutlined'
import {
  HeroSection,
  HomeSlider,
  LinkWithIcon,
  ProductInfoVariationForty,
  ProductInfoVariationHundred,
  ProductInfoVariationSeventy,
  ProductInfoVariationSixty,
  ProductInfoVariationThirty,
  PromoItem,
  Slash,
  XRayText,
} from '../../components'
import ProductInfoVariation60Full from '../../components/ProductInfo/ProductInfoVariation60Full'
import { contentfulArrayToObject, getDescription } from '../../utils/cms'
import { useStyles } from './autoLeasing.styles'
import { useHeroStyles, useStyles as useHomeStyles } from '../home/Home.styles'
import { SLASH_HEIGHT } from '../../constants'
import { productFeaturesData } from './productFeaturesData'
import SingleSlider from '../../components/SingleSlider/SingleSlider'
import ArrowIcon from '../../components/ArrowIcon'

const AutoLeasingPage = ({ t, language, footerNode, data = {}, ...props }) => {
  const styles = useStyles()
  const homeStyles = useHomeStyles()
  const theme = useTheme()

  const slashHeight = SLASH_HEIGHT

  const newHeight = useMediaQuery(theme.breakpoints.down('sm'))
    ? slashHeight * 0.5
    : slashHeight
  const slashMaxGrowth = footerNode?.clientHeight / newHeight

  const { hero, sections } = data

  const {
    ContentfulHomepageServices: services,
    ContentfulSliderBlock: sliderBlock,
    ContentfulFeatureSection: featureSection,
    ContentfulHomepageSlider: sliderSection,
    ContentfulSectionHeading: sectionHeading,
  } = contentfulArrayToObject(sections)

  const isMultipleSliders = Array.isArray(sliderSection)
  const firstSlider = isMultipleSliders ? sliderSection[0] : undefined
  const otherSliders = isMultipleSliders
    ? sliderSection.slice(1)
    : sliderSection

  // feature section
  const { featureHeading, featureCta } = featureSection || {}
  const featureDescription =
    featureSection && getDescription(featureSection.featureDescription.raw)

  return (
    <>
      <main className={homeStyles.root}>
        <Slash
          stopGrowingPositionYOffset={footerNode?.clientHeight / 3}
          startGrowingPositionYOffset={footerNode?.clientHeight * 5}
          height={newHeight}
          growthScale={{ initial: 1, target: slashMaxGrowth }}
        />
        {hero && (
          <HeroSection
            homepage
            t={t}
            {...hero}
            useCustomStyles={useHeroStyles}
          />
        )}
        {firstSlider && (
          <SingleSlider
            sliderData={firstSlider}
            buttonIcon={<PictureAsPdfOutlinedIcon />}
          />
        )}
        {sectionHeading && (
          <Box className={homeStyles.servicesTitle}>
            <XRayText
              isXray
              variant="h1"
              content={sectionHeading.sectionHeadings}
            />
          </Box>
        )}

        <Container maxWidth="lg">
          {services.map(
            (
              {
                imageToRight,
                serviceHeading,
                serviceDescription,
                serviceImages,
                serviceCta,
                fallbackUrl,
              },
              index,
            ) => (
              <PromoItem
                key={`promo-item-${index}`}
                reverse={!imageToRight}
                title={serviceHeading}
                description={getDescription(serviceDescription?.raw || '')}
                animationPath={
                  serviceImages ? serviceImages[0]?.image?.file.url : undefined
                }
                placeholderPath={
                  serviceImages ? serviceImages[0]?.bucketUrl : fallbackUrl
                }
                cta={serviceCta}
              />
            ),
          )}
        </Container>
        {featureSection && (
          <Container maxWidth="md">
            <Box className={styles.sectionHeading}>
              <XRayText isXray variant="h3" content={featureHeading} />
              <Typography className={styles.sectionDescription} variant="body1">
                {featureDescription}
              </Typography>
              {featureCta && (
                <LinkWithIcon
                  text={featureCta.title}
                  to={featureCta.link}
                  isExternal={featureCta.isExternal}
                  className={styles.sectionDescription}
                />
              )}
            </Box>
          </Container>
        )}
        {props.productFeatureType && (
          <Container maxWidth="md" className={styles.productInfoContainer}>
            {productFeaturesData[props.productFeatureType].map((feature) => {
              switch (feature.type) {
                case 'THIRTY':
                  return <ProductInfoVariationThirty {...feature} t={t} />
                case 'FORTY':
                  return <ProductInfoVariationForty {...feature} t={t} />
                case 'SIXTY':
                  return <ProductInfoVariationSixty {...feature} t={t} />
                case 'SIXTY-FULL':
                  return <ProductInfoVariation60Full {...feature} t={t} />
                case 'SEVENTY':
                  return <ProductInfoVariationSeventy {...feature} t={t} />
                case 'HUNDRED':
                  return <ProductInfoVariationHundred {...feature} t={t} />
                default:
                  return null
              }
            })}
          </Container>
        )}
        {sliderBlock?.sliderHeading && (
          <Box>
            <XRayText
              isXray
              variant="h1"
              content={sliderBlock.sliderHeading}
              textClass={homeStyles.homeSliderHeading}
            />
            <HomeSlider data={sliderBlock} />
          </Box>
        )}
        {otherSliders?.map((slider, idx) => (
          <SingleSlider
            key={idx}
            sliderData={slider}
            buttonIcon={<ArrowIcon direction="forward" />}
          />
        ))}
      </main>
    </>
  )
}

export default AutoLeasingPage
